import { api } from '../api/instance';

/**
 * deleteUpload
 * @param {String} file file to delete
 * @param {Function} setter function to update state
 */
const deleteUpload = async (file, setter) => {
  const response = await api.post('/file/delete', {
    filePath: file,
  });

  if (response.message === 'enoent') {
    setter((prevState) => ({
      ...prevState,
      images: prevState.images.filter((image) => image.path !== file),
    }));
  }

  if (response.status === 200) {
    console.log('image deleted');
    // cant add the same file again after deletion
    setter((prevState) => ({
      ...prevState,
      images: prevState.images.filter((image) => image.path !== file),
    }));
  }

  if (response.status === 409) {
    console.log('An error has occurred');
  }
}; // DELETE FILE

export default deleteUpload;
